import { PlatformType } from "@/entities/Company";

export const PLATFORM_TYPE_LABELS = {
    [PlatformType.BANK]: "Bank",
    [PlatformType.ACCOUTING]: "Accounting",
    [PlatformType.PAYMENTS]: "Payments",
};
